module.exports = __webpack_public_path__ + "img/11_d.d0f32aba.jpg";